import { extractTopLevelDomain } from './tld';

const VISTA_COM_HOST = 'vista.com';

export const getCurrentCountry = (host: string, path: string) => {
  let tld;

  // Backwards compatibility for testing
  if (host === 'localhost') {
    tld = 'IE';
  } else if (host === VISTA_COM_HOST) {
    tld = path === '/' ? 'us' : path.substr(1, 2);
  } else {
    tld = extractTopLevelDomain(host);
  }

  switch (tld.toLowerCase()) {
    case 'pt':
      return 'PT';
    case 'ie':
      return 'IE';
    case 'es':
      return 'ES';
    case 'in':
      return 'IN';
    case 'jp':
      return 'JP';
    case 'com':
    case 'us':
      return 'US';
    case 'fr':
      return 'FR';
    case 'it':
      return 'IT';
    case 'uk':
      return 'GB';
    case 'de':
      return 'DE';
    case 'nl':
      return 'NL';
    case 'dk':
      return 'DK';
    case 'se':
      return 'SE';
    case 'at':
      return 'AT';
    case 'no':
      return 'NO';
    case 'fi':
      return 'FI';
    case 'be':
      return 'BE';
    case 'sg':
      return 'SG';
    case 'nz':
      return 'NZ';
    case 'au':
      return 'AU';
    case 'ca':
      return 'CA';
    case 'ch':
      return 'CH';
  }

  throw new Error(`Unknown country for host ${host} and path ${path}`);
};
